interface CustomWindow extends Window {
    onStepChangeEvent?: () => void;
}

const fireStepChangeEvent = () => {
  console.log("fireStepChangeEvent...")
  try {
    // fire the utag link event
    if ((window as CustomWindow).onStepChangeEvent) {
      (window as CustomWindow).onStepChangeEvent!();
    }
  } catch (e) {
    console.log(
      'onStepChangeEvent failed - please check the Assessment Step Change Script'
    );
  }
};

export default fireStepChangeEvent;
